/* Cristina Gavino — animaciones de entrada */
(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.cg-reveal:not(.cg-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('cg-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cg-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveal(); });
  } else { initReveal(); }
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
})();